import { useTheme } from '@automata/mui-theme';
import { GridColumns } from '@visx/grid';
import { GridLines } from '@visx/grid/lib/types';
import { Line } from '@visx/shape';
import { ScaleLinear } from 'd3-scale';

type GridProps = {
  height: number;
  width: number;
  scaleX: ScaleLinear<number, number, never>;
};

export const Grid = ({ height, width, scaleX }: GridProps): JSX.Element => {
  const theme = useTheme();
  return (
    <GridColumns
      height={height}
      scale={scaleX}
      numTicks={Math.floor(width / 12)}
    >
      {({ lines }: { lines: GridLines }) =>
        lines.map((line, i) => (
          <Line
            key={`column-line-${i}`}
            data-testid={`column-line-${i}`}
            from={line.from}
            to={line.to}
            stroke={
              i === 0 ? theme.palette.neutral[400] : theme.palette.neutral[300]
            }
            strokeWidth={i % 10 === 0 ? 1 : 0}
          />
        ))
      }
    </GridColumns>
  );
};
